// Cloudflare Workers API endpoints
const API_BASE = import.meta.env.VITE_API_URL || 'https://yearcompass-api.horacexz.workers.dev'

/**
 * 保存数据到云端
 * @param {string} userId - 用户 ID
 * @param {object} data - 要保存的数据
 * @returns {Promise<object>} 保存结果
 */
export async function saveToCloud(userId, data) {
  try {
    const response = await fetch(`${API_BASE}/api/save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: userId,
        data: data
      })
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const result = await response.json()
    console.log('数据已保存到云端:', result)
    return result
  } catch (error) {
    console.error('保存到云端失败:', error)
    // 不抛出错误，允许应用继续运行
    return null
  }
}

/**
 * 从云端加载数据
 * @param {string} userId - 用户 ID
 * @returns {Promise<object|null>} 加载的数据，如果不存在返回 null
 */
export async function loadFromCloud(userId) {
  try {
    const response = await fetch(`${API_BASE}/api/load/${userId}`)

    if (response.status === 404) {
      console.log('云端未找到数据')
      return null
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const result = await response.json()

    if (result.success && result.data) {
      console.log('成功从云端加载数据')
      return result.data
    }

    return null
  } catch (error) {
    console.error('从云端加载失败:', error)
    // 不抛出错误，允许应用继续运行
    return null
  }
}

export async function exportToPDF(data) {
  try {
    const response = await fetch(`${API_BASE}/api/export`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })

    if (!response.ok) {
      throw new Error('Failed to export PDF')
    }

    return await response.json()
  } catch (error) {
    console.error('Export PDF error:', error)
    throw error
  }
}
